import { Permission } from "./permission";
import { PaginatedResponse } from "./paginated-response";

export class Project {
  id: string;
  active: boolean;
  name: string;
  shortName: string;
  deliveryDate: string;
  value: string;
  summary: string;
  icon: string;
  status: string;
  orders: string[];
  worksheets: string[];
  masterBoms: string[];
  created: string;
  marketId: string;
  createdBy: string;
  accountNumber: string;
  organizationId: string;
  projectPermissions: ProjectPermission[];
  updateProjectPermission: boolean;
  inheritMarketPermissions: boolean;
  projectNumber?: string;
  reca: boolean = false;
  isSelected: boolean = true;
  fuzeId: string;

  constructor(data: any = {}) {
    this.name = data.name || '';
    this.deliveryDate = data.deliveryDate || new Date().toLocaleDateString();
    this.value = data.value || '0';
    this.summary = data.summary || '';
    this.icon = data.icon || '&#xe' + (2306).toString(16);
    this.status = data.status || 'Tampa';
    this.marketId = '';
    this.accountNumber = '';
    this.fuzeId = data.fuzeId || null;
  }
}

export class ProjectPermission extends Permission {
  marketInherit: boolean;
}

export class PaginatedProjectDTO extends PaginatedResponse {
  records: Project[];
}

export class ProjectUserInput {
  userId: string;
  projectStatus: boolean;
  projectStatusString: string;
  projectSearchText: string;
  projectIds: string[];

  constructor(userId: string, projectStatus: boolean, projectStatusString: string, projectSearchText?: string, projectIds?: string[]) {
    this.userId = userId;
    this.projectStatus = projectStatus;
    this.projectStatusString = projectStatusString;
    this.projectSearchText = projectSearchText;
    this.projectIds = projectIds;
  }
}

export class AllProject {
  id:string;
  name:string;

  constructor(id:string,name:string){
    this.id = id;
    this.name = name;
  }
}


// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/models/project-model.ts